/**
 * Created by tatekim on 2017. 2. 2..
 */
(function() {
    'use strict';
    var app = angular.module('admin');

    app.config(function($provide) {
        $provide.decorator("$ocLazyLoad", ["$delegate", "$q", "vv", function($delegate, $q, vv) {
            $delegate.jsLoader = function (paths, callback, params) {
                vv.importScript(paths, params).then(function() {
                    callback();
                }).catch(function(err) {
                    callback(err);
                });
            };
            var oldCssLoader = $delegate.cssLoader;
            var staticRoot = vv.getVvMetaData('static_root');
            $delegate.cssLoader = function (paths, callback, params) {
                var newPaths = [];
                angular.forEach(paths, function(path) {
                    if (path.indexOf('/') == 0 && path.indexOf('?_hv=') > 0) {
                        newPaths.push(staticRoot + path);
                    } else {
                        newPaths.push(path);
                    }
                });
                return oldCssLoader(newPaths, callback, params);
            };
            return $delegate;
        }]);
    });

    var modules = {};

    var flatModuleFiles = function(files) {
        var newFiles = [];
        angular.forEach(files, function(file) {
            if (file in modules) {
                angular.forEach(modules[file].files, function(module_file) {
                    newFiles.push(module_file);
                });
            } else {
                newFiles.push(file);
            }
        });
        return newFiles;
    };

    var vvModule = function(name, files, options) {
        var module = {
            name: name,
            files: flatModuleFiles(files),
        };
        if (options)
            angular.extend(module, options);
        modules[module.name] = module;
        return module;
    };

    app.config(['$ocLazyLoadProvider', function($ocLazyLoadProvider) {
        $ocLazyLoadProvider.config({
            modules: [
                vvModule('ngCSV', [
                    '/lib/ng-csv/build/ng-csv.min.js?_hv=b4a5cae',
                ]),
                vvModule('ngAudio', [
                    '/lib/angular-audio/app/angular.audio.js',
                ]),
                vvModule('admin.util', [
                    'admin-util.js',
                ]),
                vvModule('admin.quiz.util', [
                    'admin-quiz-util.js',
                ]),
                vvModule('admin.search', [
                    'admin-search.js',
                ]),
                vvModule('admin.quiz.enabled-history', [
                    'admin-quiz-enabled-history.js',
                ]),
                vvModule('admin.quiz.stats', [
                    'admin.quiz.util',
                    'admin-quiz-stats.js',
                ]),
                vvModule('admin.models', [
                    'admin.util',
                    'vonvon-qlogic.js',
                    'admin-models.js',
                ], {serie: true}),
                vvModule('admin.quiz.image_previewer', [
                    'image-previewer.js',
                ]),
                vvModule('admin.quiz', [
                    'ngAudio',
                    'admin.models',
                    'admin.util',
                    'admin.quiz.util',
                    'admin.quiz.stats',
                    'admin.quiz.image_previewer',
                    "vonvon-task-util.min.js",
                    'admin-quiz.js',
                ]),
                vvModule('admin.trend.chart', [
                    'admin-trend-chart.js',
                ]),
                vvModule('admin.trend', [
                    'admin-trend.js',
                    "vonvon-task-util.min.js",
                    'admin.trend.chart',
                ]),
                vvModule('mImageUploader', [
                    'm-image-uploader.js',
                ]),
                vvModule('cropperjs', [
                    '/lib/cropperjs/dist/cropper.min.js'
                ]),
                vvModule('admin.quiz.go.edit', [
                  'admin-quiz-go-edit.js',
                ]),
                vvModule('admin.user.mypage', [
                  'admin-admin_user-mypage.js'
                ]),
                vvModule('admin.user.manage', [
                  'admin-admin_user-manage.js'
                ]),
                vvModule('admin.user.approve', [
                  'admin-admin_user-approve.js'
                ]),
                vvModule('admin.user.secret', [
                  'admin-admin_user-secret.js'
                ]),
                vvModule('admin.app.notifier', [
                  'admin-app-notifier.js'
                ]),
                vvModule('admin.privacy_info', [
                  'admin-privacy-info.js',
                ]),
                vvModule('admin.quiz.export', [
                  'admin-quiz-export.js'
                ]),
                vvModule('admin.translate.test', [
                  'admin-translate-test.js'
                ]),
                vvModule('admin.quiz.translate.review.list', [
                  'admin-quiz-translate-review-list.js'
                ]),
                vvModule('admin.quiz.translate', [
                  'admin-quiz-translate.js'
                ]),
                vvModule('admin.quiz.inspect', [
                  'admin-quiz-inspect.js'
                ]),
                vvModule('admin.quiz.search', [
                  'admin-quiz-search.js'
                ]),
                vvModule('admin.push_schedule', [
                  'admin-push-schedule.js'
                ]),
                vvModule('admin.specialMigration', [
                  'admin-quiz-special-migration.js'
                ]),
            ],
        });
    }]);

})();
